import React, { useEffect, useState } from 'react';
import { Toolbar, Typography, TextField, Tooltip, IconButton } from '@material-ui/core';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import { People, TextRotateUp, CloudDownload, CreateNewFolder, Adjust, CloudUpload, Delete } from '@material-ui/icons';
import CgSelect from '../core/CgSelect';
import Groupbox from '../core/Groupbox';

const VIEWABLETYPES = ['pdf', 'docx', 'xlst', 'png', 'jpeg', 'bmp'];

export function MyToolbar(props) {

    var { onFilterChange, node, multipleNodeIds, isAdmin,
        newClient, view, download, create, rename, upload, onDelete,
        orderCriteria, onOrderCriteriaChange
    } = props;


    const isClient = node && node.type === 'client';
    const isFolder = node && node.hasChildren;
    const isFile = node && !node.hasChildren;
    const isViewable = node && VIEWABLETYPES.indexOf(node.type) > -1;
    const name = node && node.name;

    const isAllowNewClient = isAdmin;
    const isAllowNewFolder = node && isAdmin && isFolder;
    const isAllowRename = node && isAdmin;
    const isAllowPreview = node && isFile && isViewable;
    const isAllowDownload = (node && isFile) || (multipleNodeIds && multipleNodeIds.length > 0);
    const isAllowUpload = node && ((isAdmin && isFolder) || (name && name.includes("Upload")));
    const isAllowDelete = (isAdmin && node) || (isAdmin && multipleNodeIds && multipleNodeIds.length > 0);

    var downloadOrDeleteName = name;
    if (multipleNodeIds && multipleNodeIds.length > 0) {
        downloadOrDeleteName = `The ${multipleNodeIds.length} selected files`;
    }

    return (
        <Toolbar style={{ backgroundColor: '#eee', boxShadow: '3px 3px #ccc', borderRadius: '3px' }}>
            <Typography variant="h6" color="primary" style={{ marginRight: '30px' }}>DocX</Typography>

            <TextField label='Filter Clients'
                onChange={e => onFilterChange(e.target.value)}
                variant='outlined' />
            
            {
                isAllowNewClient ?
                <Tooltip title={'New Client'}><div><IconButton onClick={newClient}
                ><People /></IconButton></div></Tooltip>
                    : ''
            }
            {
                isAllowPreview ?
                <Tooltip title={'Preview ' + name}><div><IconButton onClick={view}
                ><TextRotateUp /></IconButton></div></Tooltip>
                    : ''
            }
            {
                isAllowDownload ?
                    <Tooltip title={'Download ' + downloadOrDeleteName}><div><IconButton
                    onClick={download}><CloudDownload /></IconButton></div></Tooltip>
                    : ''
            }
            {

            }
            {
                isAllowNewFolder ?
                <Tooltip title={'New Folder to ' + name}><div><IconButton
                    disabled={!isFolder} onClick={create}><CreateNewFolder /></IconButton></div></Tooltip>
                    : ''
            }
            {
                isAllowRename ?
                <Tooltip title={'Rename ' + name}><div><IconButton
                    disabled={''} onClick={rename}><Adjust /></IconButton></div></Tooltip>
                   : ''
            }

            {
                 isAllowUpload ?
                <Tooltip title={'Upload to ' + name}><div><IconButton
                    disabled={!isFolder} onClick={upload}><CloudUpload /></IconButton></div></Tooltip>
                     : ''
            }
            {
                isAllowDelete ?
                    <Tooltip style={{ marginLeft: '100px' }} color='secondary' title={'Delete ' + downloadOrDeleteName}>
                        <div><IconButton onClick={onDelete}><Delete /></IconButton></div>
                </Tooltip>
                     : ''
            }
            <FormControl variant='outlined' style={{ marginLeft: 'auto', width: '200px' }}>
                <InputLabel id="demo-simple-select-autowidth-label">Order Files By</InputLabel>
                <Select label='Order Files By'
                    labelId="demo-simple-select-autowidth-label"
                    id="demo-simple-select-autowidth"
                    value={orderCriteria}
                    onChange={e => onOrderCriteriaChange(e.target.value)}
                    autoWidth
                >
                    <MenuItem value={'Upload Date'}>Upload Date</MenuItem>
                    <MenuItem value={'Name'}>Name</MenuItem>
                    <MenuItem value={'Size'}>Size</MenuItem>
                    <MenuItem value={'Type'}>Type</MenuItem>
                    <MenuItem value={'Author'}>Author</MenuItem>
                </Select>
            </FormControl>
        </Toolbar>
        );
}